import { gql } from '@apollo/client'

export const CREATE_PASSENGER_PROPERTY = gql`
  mutation CreatePassengerProperty($input: CreatePassengerPropertyInput!) {
    createPassengerProperty(input: $input)
  }
`

export const EDIT_PASSENGER_PROPERTY = gql`
  mutation ChangePassengerProperty($input: ChangePassengerPropertyInput!) {
    changePassengerProperty(input: $input)
  }
`
export const ENABLE_PASSENGER_PROPERTY = gql`
  mutation enablePassengerProperty($input: EnablePassengerPropertyInput!) {
    enablePassengerProperty(input: $input)
  }
`

export const DISABLE_PASSENGER_PROPERTY = gql`
  mutation DisablePaseeenablePassengerProperty($input: DisablePassengerPropertyInput!) {
    disablePassengerProperty(input: $input)
  }
`
